import React from 'react';
import { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '/@/app/AppContext';
import { ScrollContext } from '/@/app/AppLayout';
import { Container, Box, Button, Tooltip, Divider, Link } from '@mui/material';
import { route } from '/@/app/routes';
import { InstallComponent } from '/@/app/PWA/InstallComponent';
import { UpdateAnnouncements } from '/@/app/components/UpdateAnnouncements';
import { ExpirationNotice } from '/@/app/components/ExpirationNotice';
import { StepInfoBlock } from '/@/app/components/StepInfoBlock';
import { SupportLinks } from '/@/app/components/SupportLinks';
import { IFrameVideo } from '/@/app/components/IFrameVideo';
import LongevityCalculator from '/@/app/components/LongevityCalculator';

export const HomeView = observer(({ userFlowState }) => {
    const { t,i18n } = useTranslation();
    const { help } = useContext(AppContext).bootstrapData;
const {restoreScroll}=useContext(ScrollContext);
restoreScroll();

    return (
        <>
            <Container maxWidth="sm" className="home-view-centered-content">
                <ExpirationNotice />
                <UpdateAnnouncements />

                <Box sx={{textAlign: "center", mt: 1 }}>
                    <InstallComponent showDebug={false} />
                </Box>
                <Box>
                    <ul>
                        <li>
                            <Button
                                variant="text"
                                component={RouterLink} to={"/nestarenie-expert.apk"} target="_blank"
                            ><img src="/favicon/favicon-32x32.png" height="24" width="24"></img>&nbsp;{t("Скачать приложение")}</Button>
                        </li>
                    </ul>
                </Box>
                <LongevityCalculator/>
            </Container>

            <Container maxWidth="sm" className="home-view-centered-content">
                <Box>
                    <ul>
                        <li>
                            <Button
                                variant="text"
                                component={RouterLink} to={route("/labs/")}
                            >{t("Шаг 1: Посетить лабораторию")}</Button>
                        </li>
                        <li>
                            <Button
                                variant="text"
                                component={RouterLink} to={route("/questions/")}
                            >{t("Шаг 2: Ответить на вопросы")}</Button>
                        </li>
                        <Tooltip title={userFlowState.stepLabTestsActive ? "" : "Сначала ответьте на все вопросы"}>
                            <li>
                                <Button
                                    variant="text"
                                    component={RouterLink}
                                    to={userFlowState.stepLabTestsActive ? route("/lab-tests/") : ""}
                                    disabled={!userFlowState.stepLabTestsActive}
                                >{t("Шаг 3: Лабораторные анализы")}</Button>
                            </li>
                        </Tooltip>
                        <Tooltip title={userFlowState.stepRisksActive ? "" : "Сначала заполните хотя бы некоторые анализы"}>
                            <li>
                                <Button
                                    variant="text"
                                    component={RouterLink}
                                    to={userFlowState.stepRisksActive ? route("/risks/") : ""}
                                    disabled={!userFlowState.stepRisksActive}
                                >{t("Шаг 4: Узнайте ваши риски")}</Button>
                            </li>
                        </Tooltip>
                        <Tooltip title={userFlowState.stepAgesActive ? "" : "Сначала пройдите предыдущий шаг"}>
                            <li>
                                <Button
                                    variant="text"
                                    component={RouterLink}
                                    to={userFlowState.stepAgesActive ? route("/age-assessments/") : ""}
                                    disabled={!userFlowState.stepAgesActive}
                                >{t("Шаг 5: Оценка возраста")}</Button>
                            </li>
                        </Tooltip>
                        <Tooltip title={userFlowState.stepPlanActive ? "" : "Сначала пройдите предыдущий шаг"}>
                            <li>
                                <Button
                                    variant="text"
                                    component={RouterLink}
                                    to={userFlowState.stepPlanActive ? route("/plan/") : ""}
                                    disabled={!userFlowState.stepPlanActive}
                                >{t("Шаг 6: Ознакомьтесь с Планом продления жизни")}</Button>
                            </li>
                        </Tooltip>
                        <Tooltip title={userFlowState.stepNextActive ? "" : "Сначала пройдите предыдущий шаг"}>
                            <li>
                                <Button
                                    variant="text"
                                    component={RouterLink}
                                    to={userFlowState.stepNextActive ? route("/next/") : ""}
                                    disabled={!userFlowState.stepNextActive}
                                >{t("Шаг 7: Что дальше")}</Button>
                            </li>
                        </Tooltip>
                    </ul>
                </Box>
            </Container>

            {/* container for the video w/o margins */}
            <Container maxWidth="md" sx={{ textAlign: "center", p: "0!important" }}>
                <IFrameVideo
                    src="https://vk.ru/video_ext.php?oid=708099998&id=456239018&hd=3&hash=06512cec30681d37"
                    placeholderContentId="intro_video_placeholder"
                    aspectRatio={1280 / 720}
                    sx={{ mt: 3, mb: 3 }}
                />
            </Container>

            <Container maxWidth="sm" className="home-view-centered-content">
                <SupportLinks />

                <StepInfoBlock text={ help.texts['main_page-footer-'+i18n.language] } />

                <Divider sx={{ mt: 4 }} />
                <Box sx={{ mt: 4, display: "flex", flexFlow: "row wrap", gap: 4, justifyContent:'center' }}>
                    <Link target="_blank" href={t('privacy-policy-url')} sx={{ color: "grey", textDecoration: "none" }}>{t('privacy-policy')}</Link>
                    <Link target="_blank" href={t('user-agreement-url')} sx={{ color: "grey", textDecoration: "none" }}>{t('user-agreement')}</Link>
                </Box>

            </Container>
        </>
    );
});
